import { ListAccountsResponseSchema } from './list-accounts.schema';
/**
 * List Accounts Endpoint Contract
 * The super-admin's customer list — the level above tenants. Super-admin only.
 */ export const listAccountsContract = {
    method: 'GET',
    path: '/api/v2/admin/accounts',
    description: 'List the accounts (customers) with their company and workspaces',
    responseSchema: ListAccountsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - invalid or missing token',
            403: 'Forbidden - not a super-admin'
        }
    }
};

//# sourceMappingURL=list-accounts.contract.js.map